<div class="voice-agent">

  <div class="agent-card">

    <!-- Agent Selection -->

    @if (!connected) {
    <div class="agent-method">

      <!-- Agent -->
      <div class="agent-select">
        <label>Select Agent</label>

        <select [(ngModel)]="selectedAgent" (ngModelChange)="onAgentChange()">

          <option [ngValue]="null">
            Select Agent
          </option>

          @for (agent of agents; track agent.agent_id) {
          <option [ngValue]="agent">
            {{ agent.agent_name }}
          </option>
          }

        </select>
      </div>


      <!-- Provider -->
      <div class="agent-select">
        <label>Select Provider</label>

        <select [(ngModel)]="selectedProvider" (ngModelChange)="onProviderChange($event)" [disabled]="!selectedAgent">

          <option [ngValue]="null">
            Select Provider
          </option>

          @for (item of provider; track item.id) {
          <option [ngValue]="item">
            {{ item.name }}
          </option>
          }

        </select>
      </div>


      <!-- Voice -->
      <div class="agent-select">
        <label>Select Voice</label>

        <select [(ngModel)]="selectedVoice" (ngModelChange)="onChangeVoice()" [disabled]="!selectedProvider">

          <option [ngValue]="null">
            Select Voice
          </option>

          @for (voice of voiceList; track voice.id) {
          <option [ngValue]="voice">
            {{ voice.name }}
          </option>
          }

        </select>
      </div>

    </div>
    }

    <!-- Avatar -->

    <div class="avatar-ring">

      <!-- Outer pulse rings -->
      <div class="pulse pulse1" [class.active]="connected && !muted">
      </div>

      <div class="pulse pulse2" [class.active]="connected && !muted">
      </div>

      <!-- Agent Avatar -->
      <div class="agent-avatar" [class.agent-avatar--speaking]="agentIsSpeaking">
        <img [src]="agentAvatar" [alt]="agentGender + ' AI Agent'" class="agent-avatar__image" />
      </div>

      <!-- Connection status -->
      <div class="status-dot" [ngClass]="{
      'connected': connected,
      'disconnected': !connected
    }">
      </div>

    </div>

    <!-- Status -->

    <div class="agent-info">

      <p>

        @if(!connected){

        Ready to connect

        }

        @if(connected && !muted){

        Connected · Speaking

        }

        @if(connected && muted){

        Connected · Type a message

        }

      </p>

      @if(connected){

      <span>

        {{ selectedAgent?.agent_name }}

      </span>

      }

    </div>

    <!-- Transcript -->

    <div class="ai-body" #transcriptContainer *ngIf="connected">

      @if(transcripts.length > 0){

      @for(item of transcripts; track item.id){

      <div class="transcript-item" [class.agent]="item.isAgent" [class.user]="!item.isAgent">

        <div class="transcript-role">

          {{ item.isAgent
          ? selectedAgent?.agent_name
          : 'You' }}

        </div>

        <div class="transcript-container">

          <div class="transcript-text">

            {{ item.text }}

          </div>

        </div>

      </div>

      }

      }

      @else {

      <div class="empty-state">

        @if(!connected){

        Select an agent and connect

        }

        @if(connected){

        Start speaking...

        }

      </div>

      }

    </div>

    <!-- Text Input -->

    @if(connected){

    <div class="chat-input">

      <input type="text" [(ngModel)]="typedMessage" placeholder="Type your message..."
        (keyup.enter)="sendTypedMessage()">

      <button class="send-btn" (click)="sendTypedMessage()">

        <i class="pi pi-send"></i>

      </button>

    </div>

    }

    <!-- Connect -->

    @if(!connected){

    <button class="connect-btn" (click)="handleConnect()" [disabled]="!selectedAgent && !selectVoice">

      <i class="pi pi-play-circle"></i>

      {{ connectLabel }}

    </button>

    }

    <!-- Controls -->

    @if(connected){

    <div class="call-controls">

      <!-- Mute -->

      <button class="icon-btn" [class.muted]="muted" (click)="handleMute()">

        <!-- <i class="pi" [ngClass]="

            muted

            ? 'pi-microphone'

            : 'pi-microphone'

          ">

        </i> -->

        <img [src]="muted ? 'assets/images/mic-off.png' : 'assets/images/mic-on.png'" width="24" height="24">

      </button>

      <!-- End -->

      <button class="end-btn" (click)="handleEnd()">

        <i class="pi pi-phone"></i>

      </button>

    </div>

    }

    <!-- Toast -->

    @if(toastMessage){

    <div class="toast">

      {{ toastMessage }}

    </div>

    }

  </div>

</div>
